export default __webpack_public_path__ + "static/calendar_scr-e08648adb8ff78b76f553fe43fcdef9a.png";